module.exports = __webpack_public_path__ + "images/emoji/black_medium_square.10f6901bd6054d537085.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_medium_square.png
// module id = KVYc
// module chunks = 13